import React, { Component } from 'react'
import Projectdetail from './Projectdetail'
import Imagerow from './components/Imagerow'
import Updates from './components/Projupdates'

export class Starter extends Component {

  render() {
    return (
      <React.Fragment>
        <Projectdetail
          image="assets/img/screenshots/lrg/12486.herokuapp.com_.jpg"
          heading="The PostMaster"
          content={[
            <>
              <p>
                This a very simple app, that a user can send out surveys to
                customers to get feedback. Some of the features of this project
                include:
              </p>

              <ul className="features">
                <li>
                  Utilizes the MERN stack, as well as the Stripe API for
                  payments, and the SendGrid API for sending emails.
                </li>

                <li>User authorization system, as well as email handling</li>

                <li>
                  User profiles where users can keep their surveys that were
                  sent out as well as customer responses
                </li>

                <li>
                  To add credits to a fictional account. Simply use the numbers
                  (4242 4242 4242). This will enable you to test out the
                  application.
                </li>
              </ul>
            </>,
          ]}
          website="https://gruesome-grave-12486.herokuapp.com/"
          github="https://github.com/Jimmyelvis/postmaster"
          techs={[
            <>
              <li>React.js</li>
              <li>Express.js</li>
              <li>MongoDB</li>
              <li>Node.js</li>
              <li>Stripe Api</li>
              <li>CSS Grid</li>
              <li>Flexbox</li>
              <li>SendGrid</li>
            </>,
          ]}
          updates={[
            <>
              <h2 className="heading-2">Recent Updates</h2>

              <div className="updates">
                <Updates
                  heading="UPDATE 4/18/2021"
                  desc={[
                    <>
                      <p>
                        Made some minor changes to the site. I changed the
                        login/register press from using a Passport
                        Google/Facebook strategy, to using a Passport Local
                        strategy. So now a user creates a username and password,
                        and then they can access the site. Also made some minor
                        changes to the Dashboard, and the login/register form.
                      </p>
                    </>,
                  ]}
                  itemImage={[
                    {
                      fullimage: "assets/img/screenshots/lrg/sign-up2.jpg",
                      screenshot: "assets/img/screenshots/lrg/sign-up2.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/create.jpg",
                      screenshot: "assets/img/screenshots/lrg/create.jpg",
                    },
                  ]}
                  gallery="UPDATE 4/18/2021"
                />

                <Updates
                  heading="UPDATE 4/13/2020"
                  desc={[
                    <>
                      <p>
                        Completely redesigned the look of the site using CSS
                        Grid and Flexbox, to give the site a more modern look.
                        In addition added the ability to delete surveys. And
                        added the ability to add a custom reply to field when
                        creating surveys.
                      </p>
                    </>,
                  ]}
                  itemImage={[
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/FireShot Capture 191 - The PostMaster - http___localhost_3000_.jpg",
                      screenshot:
                        "assets/img/screenshots/lrg/FireShot Capture 191 - The PostMaster - http___localhost_3000_.jpg",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/FireShot Capture 192 - The PostMaster - http___localhost_3000_.jpg",
                      screenshot:
                        "assets/img/screenshots/lrg/FireShot Capture 192 - The PostMaster - http___localhost_3000_.jpg",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/FireShot Capture 194 - The PostMaster - http___localhost_3000_contact.jpg",
                      screenshot:
                        "assets/img/screenshots/lrg/FireShot Capture 194 - The PostMaster - http___localhost_3000_contact.jpg",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/FireShot Capture 195 - The PostMaster - http___localhost_3000_dashboard.jpg",
                      screenshot:
                        "assets/img/screenshots/lrg/FireShot Capture 195 - The PostMaster - http___localhost_3000_dashboard.jpg",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/FireShot Capture 197 - The PostMaster - http___localhost_3000_surveylist.jpg",
                      screenshot:
                        "assets/img/screenshots/lrg/FireShot Capture 197 - The PostMaster - http___localhost_3000_surveylist.jpg",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/FireShot Capture 198 - The PostMaster - http___localhost_3000_surveydetail_5e34e1c188bce771cc60c8ea.jpg",
                      screenshot:
                        "assets/img/screenshots/lrg/FireShot Capture 198 - The PostMaster - http___localhost_3000_surveydetail_5e34e1c188bce771cc60c8ea.jpg",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/FireShot Capture 199 - The PostMaster - http___localhost_3000_surveys_new.jpg",
                      screenshot:
                        "assets/img/screenshots/lrg/FireShot Capture 199 - The PostMaster - http___localhost_3000_surveys_new.jpg",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/FireShot Capture 200 - The PostMaster - http___localhost_3000_surveys_new.jpg",
                      screenshot:
                        "assets/img/screenshots/lrg/FireShot Capture 200 - The PostMaster - http___localhost_3000_surveys_new.jpg",
                    },
                  ]}
                  gallery="UPDATE 4/13/2020"
                />
              </div>

            </>,
          ]}
          images={[]}
          style={{
            backgroundColor: "rgba(75, 82, 101, 1)",
            opacity: "0.6",
          }}
        />
      </React.Fragment>
    );
  }
}

export default Starter
